import { Heading, Text, Stack } from '@chakra-ui/react';
import { ContainerOverlay } from 'components/Container/ContainerOverlay';
import { BigSuccessIcon } from 'components/Icons/BigSuccessIcon';
import { useEffect } from 'react';
import { useSuccessPage } from 'store/use-success-page';
import { getClientDisplayName } from 'utils/connect-branding';
import { useAuthorizeContext } from '../AuthorizeContext';

export const SuccessPage = () => {
  const { clientName, completeAuth, client } = useAuthorizeContext() || {};
  const { successPageRedirectUrl, setSuccessPageRedirectUrl } =
    useSuccessPage();

  useEffect(() => {
    const completeSessionRedirectUrl = `${window.location.origin}/complete-session`;

    const successPageUrl = successPageRedirectUrl
      ? new URL(successPageRedirectUrl)
      : null;

    const isCompleteSessionRedirect =
      successPageUrl &&
      successPageUrl.origin + successPageUrl.pathname ===
        completeSessionRedirectUrl;

    const completeAuthWithRedirect = () => {
      if (completeAuth && successPageRedirectUrl) {
        completeAuth?.({ redirectTo: successPageRedirectUrl });
      }
      setSuccessPageRedirectUrl(null);
    };

    // Do not wait for the timer if the redirect is to the complete-session page
    if (isCompleteSessionRedirect) {
      completeAuthWithRedirect();
      return;
    }

    const timer = setTimeout(() => {
      completeAuthWithRedirect();
    }, 1_250);

    return () => clearTimeout(timer);
  }, [completeAuth, setSuccessPageRedirectUrl, successPageRedirectUrl]);

  return (
    <ContainerOverlay isExitIntent>
      <Stack p="6" h="full" justify="space-between">
        <Stack px="6" gap="6" py="40px" align="center">
          <BigSuccessIcon />
          <Heading fontWeight="medium">Success!</Heading>
          <Text textAlign="center">
            Your account has been successfully linked to{' '}
            {getClientDisplayName(client) || clientName}
          </Text>
        </Stack>
      </Stack>
    </ContainerOverlay>
  );
};
